import useLocale from './useLocale';

const useGermanNoteSign = () => {
  const locale = useLocale();
  const germanNoteSign = locale === 'de-DE' ? '&nbsp;*' : '';

  return germanNoteSign;
};

export default useGermanNoteSign;
